export const helpdeskmgmtRouteDef = [
    {
        path: 'dashboard',
        component: 'HelpdeskDashboardComponent',
        data: {
            selector: 'app-helpdesk-dashboard'
        }
    },
    {
        path: 'project-tracker-dashboard',
        component: 'ProjectTrackerDashboardComponent',
        data: {
            selector: 'app-project-tracker-dashboard'
        }
    }
];
